function initializeModals() {
  $(".open-modal").each(function () {
    const el = $(this);

    initializeModal(el);
  });
}

function initializeModal(el) {
  el.on("mousedown", function (e) {
    e.stopPropagation();

    const modalId = $(this).data("modal-id");

    $("#" + modalId).addClass("modal__overlay_opened");
  });
}

$(document).ready(function () {
  initializeModals();

  $(".modal__overlay .modal__container").on("mousedown", function (e) {
    e.stopPropagation();
  });

  $(document).on("mousedown", function () {
    $(".modal__overlay").removeClass("modal__overlay_opened");
  });
});
